<template>
  <div class="kb-base-icon">
    <LoginIcon v-if="icon === 'login'" class="kb-base-icon__icon" />
    <SearchIcon v-if="icon === 'search'" class="kb-base-icon__icon" />
    <ToqueIcon v-if="icon === 'toque'" class="kb-base-icon__icon" />
    <ChevronDownIcon v-if="icon === 'chevron-down'" class="kb-base-icon__icon" />
    <ChevronUpIcon v-if="icon === 'chevron-up'" class="kb-base-icon__icon" />
  </div>
</template>

<script>
import LoginIcon from "./icons/login.svg?inline";
import SearchIcon from "./icons/search.svg?inline";
import ToqueIcon from "./icons/toque.svg?inline";
import ChevronDownIcon from "./icons/chevron-down.svg?inline";
import ChevronUpIcon from "./icons/chevron-up.svg?inline";

export default {
  name: "kb-base-icon",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  components: {
    LoginIcon,
    SearchIcon,
    ToqueIcon,
    ChevronDownIcon,
    ChevronUpIcon
  }
};
</script>

<style lang="scss" scoped>
.kb-base-icon {
  display: inline-flex;
  align-items: center;

  &__icon {
    width: 1em;
    height: 1em;
    fill: currentColor;
  }
}
</style>
